import { MessageImageIcon } from './MessageImageIcon';

/**
 * author: Google
 * id C4C9B194-78C3-47FB-ABF6-5129230527AC
 * name message-image
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-image.svg
 * tags
 */
export const MmsIcon = MessageImageIcon;
export default MmsIcon